import { render, staticRenderFns } from "./certDetails.vue?vue&type=template&id=0fab5fa1&scoped=true"
import script from "./certDetails.vue?vue&type=script&lang=js"
export * from "./certDetails.vue?vue&type=script&lang=js"
import style0 from "./certDetails.vue?vue&type=style&index=0&id=0fab5fa1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fab5fa1",
  null
  
)

export default component.exports